import useHttp from './httpService';

const useCountries = () => {
	const { getAll100 } = useHttp();
	const getAllCountries = (language = 'ua') => getAll100('country', 'GET',
	null,
	{'Accept-Language': `${language}`, 
	'X-Workspace': 'uaep',
	'Access-Control-Allow-Origin': '*'});
	return getAllCountries;
};

export default useCountries;
